/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoredAddressTypesListResponse } from '../../models/stored-address-types-list-response';

export interface GetStoredAddressTypes$Params {
}

export function getStoredAddressTypes(http: HttpClient, rootUrl: string, params?: GetStoredAddressTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<StoredAddressTypesListResponse>> {
  const rb = new RequestBuilder(rootUrl, getStoredAddressTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoredAddressTypesListResponse>;
    })
  );
}

getStoredAddressTypes.PATH = '/api/v1/address_types';
